<template>
  <div class="questions">
      <Question :question="questions.find(x => x.id === currentQuestion)" v-on:confirmAnswer="confirmAnswer"  />
  </div>
</template>

<script>
import Question from './Question.vue'
export default {
  name: 'Questions',
  components: {
    Question
  },
  data: function() {
    return {
      currentQuestion: 1,
    }
  },
  props: {
    questions: Array
  },
  methods: {
    confirmAnswer: function(selectedAnswer) {
      this.$emit('addToUserAnswers', selectedAnswer);
      this.$emit('addToScore', this.questions[this.currentQuestion-1].answers.find(x => x.id === selectedAnswer).points);

      if(this.currentQuestion >= this.questions.length) {
         this.$emit('changeViewTo', 'result');
      } else {
        this.currentQuestion++;
      }
    }
  }
}
</script>
